import { FrameBody } from "@npd-ng/adp-benchmark";

export default function DeviceReadinessView() {
    return (
      <FrameBody>
    <div> DeviceReadinessView</div>
      </FrameBody>
    )
  }